import { Card, CardContent } from "@/components/ui/card";
import { UserPlus, Phone, MessageSquare, Users } from "lucide-react";
import type { BldrOsStats } from "./useBldrOsStats";

interface KpiCardProps {
  title: string;
  value: number;
  icon: React.ComponentType<{ className?: string }>;
  color: string;
  bgColor: string;
}

function KpiCard({ title, value, icon: Icon, color, bgColor }: KpiCardProps) {
  return (
    <Card className="flex-1 min-w-0">
      <CardContent className="p-4">
        <div className="flex items-center gap-3">
          <div
            className="flex items-center justify-center w-10 h-10 rounded-lg shrink-0"
            style={{ backgroundColor: bgColor }}
          >
            <Icon className="w-5 h-5" style={{ color }} />
          </div>
          <div className="min-w-0">
            <p className="text-2xl font-bold leading-none">{value}</p>
            <p className="text-xs text-muted-foreground mt-1 truncate">
              {title}
            </p>
          </div>
        </div>
      </CardContent>
    </Card>
  );
}

interface KpiCardsProps {
  stats: BldrOsStats;
}

export function KpiCards({ stats }: KpiCardsProps) {
  return (
    <div className="grid grid-cols-2 md:grid-cols-4 gap-3 mb-6">
      <KpiCard
        title="Leads today"
        value={stats.leadsToday}
        icon={UserPlus}
        color="#16a34a"
        bgColor="#dcfce7"
      />
      <KpiCard
        title="Calls today"
        value={stats.callsToday}
        icon={Phone}
        color="#2563eb"
        bgColor="#dbeafe"
      />
      <KpiCard
        title="SMS today"
        value={stats.smsToday}
        icon={MessageSquare}
        color="#7c3aed"
        bgColor="#ede9fe"
      />
      <KpiCard
        title="Open contacts"
        value={stats.openContacts}
        icon={Users}
        color="#ea580c"
        bgColor="#ffedd5"
      />
    </div>
  );
}

/** Compact 2-column version for mobile */
export function KpiCardsMobile({ stats }: KpiCardsProps) {
  return (
    <div className="grid grid-cols-2 gap-2 mb-4">
      <KpiCard
        title="Leads today"
        value={stats.leadsToday}
        icon={UserPlus}
        color="#16a34a"
        bgColor="#dcfce7"
      />
      <KpiCard
        title="Calls today"
        value={stats.callsToday}
        icon={Phone}
        color="#2563eb"
        bgColor="#dbeafe"
      />
      <KpiCard
        title="SMS today"
        value={stats.smsToday}
        icon={MessageSquare}
        color="#7c3aed"
        bgColor="#ede9fe"
      />
      <KpiCard
        title="Open contacts"
        value={stats.openContacts}
        icon={Users}
        color="#ea580c"
        bgColor="#ffedd5"
      />
    </div>
  );
}
